import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import multimediaApi from '@/common/apis/common/multimediaApi.js';
import {generatekey} from '@/iamteacherpc/utils/key.js';

export const mutations = {
    setImage(state, {obj, image}) {
        if (!obj.images) {
            //단일 이미지인 경우 (Question)
            obj.image = {
                ...obj.image,
                ...image,
            };
            return;
        }

        if (image.uploadState === REQUEST_STATE.PENDING) {
            obj.images.push(image);
            return;
        }
        const storedImageIndex = obj.images.findIndex(i => i.imageKey === image.imageKey);
        obj.images.splice(storedImageIndex, 1, {
            ...obj.images[storedImageIndex],
            ...image,
        });
    },

    deleteImage(state, {obj, imageKey}) {
        if (!obj.images) {
            //단일 이미지인 경우 (Question)
            obj.image = null;
            return;
        }

        const targetImageIndex = obj.images.findIndex(image => image.imageKey === imageKey);
        obj.images.splice(targetImageIndex, 1);
    },
};

function getObj(state, payload, path, objName) {
    if (path) {
        return path.split('.').reduce((prev, key) => prev[key], state);
    }

    if (objName) {
        return payload[objName];
    }
}

export function deleteImageActionFactory({path = null, objName = null}) {
    return function({commit, state}, payload) {
        const obj = getObj(state, payload, path, objName);
        commit('deleteImage', {obj, imageKey: payload.imageKey});
    }
}

export function uploadImageActionFactory({path = null, objName = null}) {
    return function({commit, state}, payload) {
        const obj = getObj(state, payload, path, objName);
        const file = payload.file;

        const imageKey = generatekey({category: 'image'});
        commit('setImage', {obj, image: {uploadState: REQUEST_STATE.PENDING, imageKey}});

        return multimediaApi.getUploadToken()
            .then(tokenResponse => {
                return multimediaApi.startImageUpload({tokenResponse, file});
            })
            .then(response => {
                commit('setImage', {
                    obj, image: {
                        imageKey,
                        imageNo: response.imageNo,
                        index: 0,
                        url: response.path,
                        uploadState: REQUEST_STATE.SUCCESS,
                    },
                });
            })
            .catch(e => {
                commit('deleteImage', {obj, imageKey});
                return Promise.reject(e);
            });
    }
}

